// Main System Loader
export const MAIN_SYSTEM_LOADER_SUCCESS_MSG = "Tenant Info Retrieved Successfully";
export const MAIN_SYSTEM_LOADER_ERROR_MSG = "Could Not Retrieve Tenant Info.";
// Verify Username
export const VERIFY_USERNAME_SUCCESS_MSG = "Account Details Verified Successfully";
export const VERIFY_USERNAME_ERROR_MSG = "Could Not Verify Account Details";
// Send OTP 
export const SEND_TENANT_USER_ACCOUNT_OTP_ERROR_MSG = "Could Not Send OTP.";
export const SEND_TENANT_USER_ACCOUNT_OTP_SUCCESS_MSG = "OTP Successfully Sent.";
// Verify OTP 
export const VERIFY_TENANT_USER_ACCOUNT_OTP_ERROR_MSG = "Could Not Verify OTP.";
export const VERIFY_TENANT_USER_ACCOUNT_OTP_SUCCESS_MSG = "OTP Successfully Verified.";
// Retrieve Tenant List
export const RETRIEVE_TENANTS_LIST_ERROR_MSG = "Could Not Retrieve Tenants List.";
export const RETRIEVE_TENANTS_LIST_SUCCESS_MSG = "Tenants List Retrieved Successfully.";
// Create Tenant
export const CREATE_TENANT_ERROR_MSG = "Could Not Create Tenant.";
export const CREATE_TENANT_SUCCESS_MSG = "Tenants Created Successfully.";
// Retrieve Product Types
export const RETIREVE_PRODUCT_TYPES_ERROR_MSG = "Could Not Retrieve Product Types.";
export const RETIREVE_PRODUCT_TYPES_SUCCESS_MSG = "Product Types Retrieved Successfully.";
// Add Product Type
export const ADD_PRODUCT_TYPE_ERROR_MSG = "Could Not Add Product Type.";
export const ADD_PRODUCT_TYPE_SUCCESS_MSG = "Product Type Added Successfully.";
// Retrieve Product
export const RETIREVE_PRODUCT_ERROR_MSG = "Could Not Retrieve Products.";
export const RETIREVE_PRODUCT_SUCCESS_MSG = "Products Retrieved Successfully.";
// Add Product
export const ADD_PRODUCT_ERROR_MSG = "Could Not Add Product.";
export const ADD_PRODUCT_SUCCESS_MSG = "Product Added Successfully.";
// Retrieve Warehouse Sites
export const RETIREVE_WAREHOUSE_SITES_ERROR_MSG = "Could Not Retrieve Warehouse Sites.";
export const RETIREVE_WAREHOUSE_SITES_SUCCESS_MSG = "Warehouse Sites Retrieved Successfully.";
// Retrieve Warehouse Sites
export const ADD_WAREHOUSE_SITE_ERROR_MSG = "Could Not Add Warehouse Site.";
export const ADD_WAREHOUSE_SITE_SUCCESS_MSG = "Warehouse Site Added Successfully.";
// Retrieve Audit Trails
export const RETRIVE_AUDIT_TRAILS_ERROR_MSG = "Could Not Retrive Audit Trails.";
export const RETRIVE_AUDIT_TRAILS_SUCCESS_MSG = "Audit Trails Successfully.";
// Retrieve Audit Trails
export const RETRIVE_TENANT_PROFILES_LIST_ERROR_MSG = "Could Not Retrieve Profiles.";
export const RETRIVE_TENANT_PROFILES_LIST_SUCCESS_MSG = "Profiles Successfully.";
// Retrieve Audit Trails
export const RETRIVE_SPECIFIC_TENANT_SETTINGS_ERROR_MSG = "Could Not Retrive Settings.";
export const RETRIVE_SPECIFIC_TENANT_SETTINGS_SUCCESS_MSG = "Settings Successfully.";
// Update Tenant Logo
export const UPDATE_TENANT_LOGO_ERROR_MSG = "Could Not Update Logo.";
export const UPDATE_TENANT_LOGO_SUCCESS_MSG = "Logo Updated Successfully.";
// Retrieve Profile Details
export const RETRIVE_PROFILE_DETAILS_ERROR_MSG = "Could Not Retrive Profile Details.";
export const RETRIVE_PROFILE_DETAILS_SUCCESS_MSG = "Profile Details Successfully.";
// Retrieve Profile Details
export const RETRIVE_TENANT_PROFILE_ROLES_ERROR_MSG = "Could Not Retrive Profile Roles.";
export const RETRIVE_TENANT_PROFILE_ROLES_SUCCESS_MSG = "Profile Roles Successfully.";
// Update Tenant Profile Roles
export const UPDATE_TENANT_PROFILE_ROLE_ERROR_MSG = "Could Not Update Profile Role.";
export const UPDATE_TENANT_PROFILE_ROLE_SUCCESS_MSG = "Profile Role Updated Successfully.";
// Retrieve Profile Details
export const RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_ERROR_MSG = "Could Not Retrive Product Details.";
export const RETRIVE_SPECIFIC_TENANT_PRODUCT_DETAILS_SUCCESS_MSG = "Product Details Retrieved Successfully.";
// Retrieve Profile Details
export const RETRIVE_ADD_STOCK_DETAILS_ERROR_MSG = "Could Not Retrive Product Details.";
export const RETRIVE_ADD_STOCK_DETAILS_SUCCESS_MSG = "Product Details Retrieved Successfully.";
// Add Product Stock
export const ADD_PRODUCT_STOCK_ERROR_MSG = "Could Not Add Product Stock.";
export const ADD_PRODUCT_STOCK_SUCCESS_MSG = "Product Stocked Added Successfully.";
// Retrieve Sales Reps
export const RETRIEVE_SALES_REPRESENTATIVES_ERROR_MSG = "Could Not Retrieve Sales Representatives.";
export const RETRIEVE_SALES_REPRESENTATIVES_SUCCESS_MSG = "Sales Representatives Retrieved Successfully.";
// Retrieve Categories
export const RETRIEVE_BRANDS_ERROR_MSG = "Could Not Retrieve Brands.";
export const RETRIEVE_BRANDS_SUCCESS_MSG = "Brands Retrieved Successfully.";
// Add Sales Reps
export const ADD_TENANT_SALES_REPRESENTATIVES_ERROR_MSG = "Could Not Add Sales Representatives.";
export const ADD_TENANT_SALES_REPRESENTATIVES_SUCCESS_MSG = "Sales Representatives Added Successfully.";
// Retrieve Cart List
export const RETRIEVE_CART_LIST_ERROR_MSG = "Could Not Retrieve Order List.";
export const RETRIEVE_CART_LIST_SUCCESS_MSG = "Order List Retrieved Successfully.";
// Add Product to Cart
export const ADD_PRODUCT_TO_CART_ERROR_MSG = "Could Not Add Product to Order.";
export const ADD_PRODUCT_TO_CART_SUCCESS_MSG = "Product Added to Order Successfully.";
// Update Tenant Email Credentials
export const UPDATE_TENANT_EMAIL_CREDENTIALS_ERROR_MSG = "Could Not Update Email Credentials.";
export const UPDATE_TENANT_EMAIL_CREDENTIALS_SUCCESS_MSG = "Email Credentials Updated Successfully.";
// Add Profile to Tenant
export const ADD_EMPLOYEE_TO_TENANT_ERROR_MSG = "Could Not Add Profile.";
export const ADD_EMPLOYEE_TO_TENANT_SUCCESS_MSG = "Profile Added Successfully.";
// Retrieve Tenant Orders List
export const RETRIEVE_TENANT_ORDERS_LIST_ERROR_MSG = "Could Not Retrieve Orders List.";
export const RETRIEVE_TENANT_ORDERS_LIST_SUCCESS_MSG = "Orders List Retrieved Successfully.";
// Update Tenant SMS Credentials
export const UPDATE_TENANT_SMS_CREDENTIALS_ERROR_MSG = "Could Not Update SMS Credentials.";
export const UPDATE_TENANT_SMS_CREDENTIALS_SUCCESS_MSG = "SMS Credentials Updated Successfully.";
// Retrieve Profile Details
export const RETRIVE_SPECIFIC_TENANT_ORDER_DETAILS_ERROR_MSG = "Could Not Retrive Order Details.";
export const RETRIVE_SPECIFIC_TENANT_ORDER_SUCCESS_MSG = "Order Details Retrieved Successfully.";
// Retrieve Profile Details
export const UPDATE_TENANT_ORDER_STATUS_DETAILS_ERROR_MSG = "Could Not Update Order Status.";
export const UPDATE_TENANT_ORDER_STATUS_SUCCESS_MSG = "Order Status Update Successfully.";
// Retrieve Tenant Details
export const RETRIVE_SPECIFIC_TENANT_DETAILS_ERROR_MSG = "Could Not Retrive Details.";
export const RETRIVE_SPECIFIC_TENANT_DETAILS_SUCCESS_MSG = "Details Retrieved Successfully.";
// Create Tenant Order Dispatch
export const CREATE_TENANT_ORDER_DISPATCH_DETAILS_ERROR_MSG = "Could Not Create Dispatch.";
export const CREATE_TENANT_ORDER_DISPATCH_SUCCESS_MSG = "Dispatch Created Successfully.";
// Retrieve Dispatch Details
export const RETRIVE_TENANT_DISPATCH_DETAILS_ERROR_MSG = "Could Not Retrive Dispatch Details.";
export const RETRIVE_TENANT_DISPATCH_DETAILS_SUCCESS_MSG = "Dispatch Details Successfully.";
// Add Products and Complete Dispatch
export const ADD_PRODUCTS_TO_DISPATCH_AND_COMPLETE_DISPATCH_ERROR_MSG = "Could Not Complete Dispatch.";
export const ADD_PRODUCTS_TO_DISPATCH_AND_COMPLETE_DISPATCH_SUCCESS_MSG = "Dispatch Completed Successfully.";
// Confirm Dispatch Delivery
export const SALES_REP_CONFIRM_DISPATCH_DELIVERY_ERROR_MSG = "Could Not Confirm Dispatch Delivery.";
export const SALES_REP_CONFIRM_DISPATCH_DELIVERY_SUCCESS_MSG = "Dispatch Delivery Confirmed Successfully.";
// Retrieve Tenants Goods Received
export const RETRIEVE_TENANT_GOODS_RECEIVED_ERROR_MSG = "Could Not Retrieve Goods Received.";
export const RETRIEVE_TENANT_GOODS_RECEIVED_SUCCESS_MSG = "Goods Received Received Confirmed Successfully.";
// Add Tenant Goods Received
export const ADD_TENANT_GOODS_RECEIVED_ERROR_MSG = "Could Not Add Goods Received.";
export const ADD_TENANT_GOODS_RECEIVED_SUCCESS_MSG = "Goods Received Added Successfully.";
// Retrieve Goods Received Details
export const RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_ERROR_MSG = "Could Not Retrieve Goods Received Details.";
export const RETRIEVE_SPECIFIC_TENANT_GOODS_RECEIVED_DETAILS_SUCCESS_MSG = "Goods Received Details Retrieved Successfully.";
// Add Tenant Goods Received Products
export const ADD_TENANT_GOODS_RECEIVED_PRODUCTS_ERROR_MSG = "Could Not Add Goods Received Products.";
export const ADD_TENANT_GOODS_RECEIVED_PRODUCTS_SUCCESS_MSG = "Goods Received Products Added Successfully.";
// Retrieve Tenant Dashboard Data
export const RETRIEVE_TENANT_DASHBOARD_DATA_ERROR_MSG = "Could Not Retrieve Dashboard Data.";
export const RETRIEVE_TENANT_DASHBOARD_DATA_SUCCESS_MSG = "Dashboard Data Retrieved Successfully.";
// Update Tenant Logo
export const UPDATE_TENANT_PRODUCT_IMAGE_ERROR_MSG = "Could Not Update Product Image.";
export const UPDATE_TENANT_PRODUCT_IMAGE_SUCCESS_MSG = " Product Image Updated Successfully.";
// Back Date Order
export const TENANT_BACK_DATE_ORDER_ERROR_MSG = "Could Not Back Date Order.";
export const TENANT_BACK_DATE_ORDER_SUCCESS_MSG = "Order Back Dated Successfully.";
// Add Products to Back Dated Order
export const TENANT_ADD_PRODUCTS_BACK_DATE_ORDER_ERROR_MSG = "Could Not Add Products to Back Dated Order.";
export const TENANT_ADD_PRODUCTS_BACK_DATE_ORDER_SUCCESS_MSG = "Products Added to Back Dated Order Successfully.";
// Retrieve Stock Take List
export const RETRIEVE_TENANT_STOCK_TAKE_LIST_ERROR_MSG = "Could Not Retrieve Stock Take List.";
export const RETRIEVE_TENANT_STOCK_TAKE_LIST_SUCCESS_MSG = "Stock Take List Retrieved Successfully.";
// Retrieve Stock Take Starting Balance
export const RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_ERROR_MSG = "Could Not Retrieve Stock Starting Balance.";
export const RETRIEVE_TENANT_STOCK_TAKE_STARTING_BALANCE_SUCCESS_MSG = "Stock Take Starting Balance Retrieved Successfully.";
// Tenant Create Stock Take
export const TENANT_CREATE_STOCK_TAKE_ERROR_MSG = "Could Not Create Stock Take.";
export const TENANT_CREATE_STOCK_TAKE_SUCCESS_MSG = "Stock Take Created Successfully.";
// Tenant Create Stock Take
export const RETRIEVE_TENANT_STOCK_TAKE_DETAILS_ERROR_MSG = "Could Not Retrieve Stock Details.";
export const RETRIEVE_TENANT_STOCK_TAKE_DETAILS_SUCCESS_MSG = "Stock Take Details Retrieved Successfully.";
// Tenant Create Stock Take
export const RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS_ERROR_MSG = "Could Not Retrieve Stock Preview Details.";
export const RETRIEVE_TENANT_STOCK_TAKE_PREVIEW_DETAILS = "Stock Take Preview Details Retrieved Successfully.";
// Tenant Submit Stock Take Report
export const TENANT_SUBMIT_STOCK_TAKE_REPORT_ERROR_MSG = "Could Not Submit Stock Take Report.";
export const TENANT_SUBMIT_STOCK_TAKE_REPORT_SUCCESS_MSG = "Stock Take Report Successfully Submitted.";
// Tenant Update Product Details
export const TENANT_UPDATE_PRODUCT_DETAILS_ERROR_MSG = "Could Not Update Product Details.";
export const TENANT_UPDATE_PRODUCT_DETAILS_SUCCESS_MSG = "Product Details Updated Successfully.";
// Retrieve Tenant Product Analytics
export const RETRIEVE_TENANT_PRODUCT_ANALYTICS_ERROR_MSG = "Could Not Retrieve Product Analytics.";
export const RETRIEVE_TENANT_PRODUCT_ANALYTICS_SUCCESS_MSG = "Product Analytics Retrieved Successfully.";
// Retrieve Tenant Order Analytics
export const RETRIEVE_TENANT_ORDER_ANALYTICS_ERROR_MSG = "Could Not Retrieve Order Analytics.";
export const RETRIEVE_TENANT_ORDER_ANALYTICS_SUCCESS_MSG = "Order Analytics Retrieved Successfully.";
// Retrieve Tenant Product Analytics
export const RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_ERROR_MSG = "Could Not Retrieve Warehouse Inventory Analytics.";
export const RETRIEVE_TENANT_WAREHOUSE_INVENTORY_ANALYTICS_SUCCESS_MSG = "Warehouse Inventory Analytics Retrieved Successfully.";
// Update Tenant Order Units
export const TENANT_UPDATE_ORDER_UNITS_ERROR_MSG = "Could Not Update Order Units.";
export const TENANT_UPDATE_ORDER_UNITS_SUCCESS_MSG = "Order Units Updated Successfully.";
// Retrieve Tenant Order Approvals
export const RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_ERROR_MSG = "Could Not Retrieve Order Approvals.";
export const RETRIEVE_TENANT_ORDER_APPROVALS_AND_SALES_REPRESENTATIVES_SUCCESS_MSG = "Order Approvals Retrieved Successfully.";
// Update Tenant Order Approvals
export const TENANT_UPDATE_ORDER_APPROVERS_ERROR_MSG = "Could Not Update Order Approvals.";
export const TENANT_UPDATE_ORDER_APPROVERS_SUCCESS_MSG = "Order Approvals Updated Successfully.";
// Retireve Tenant Agencies
export const RETRIEVE_TENANT_AGENCIES_ERROR_MSG = "Could Not Retrieve Agencies.";
export const RETRIEVE_TENANT_AGENCIES_SUCCESS_MSG = "Agencies Retrieved Successfully.";
// Add Tenant Agencies
export const ADD_TENANT_AGENCIES_ERROR_MSG = "Could Not Add Agencies.";
export const ADD_TENANT_AGENCIES_SUCCESS_MSG = "Agencies Added Successfully.";
// Retireve Tenant Agency Details
export const RETRIEVE_TENANT_AGENCY_DETAILS_ERROR_MSG = "Could Not Retrieve Agency Details.";
export const RETRIEVE_TENANT_AGENCY_DETAILS_SUCCESS_MSG = "Agency Details Retrieved Successfully.";
// Tenant Add Sales Reps to Agency
export const TENANT_ADD_SALES_REPS_TO_AGENCY_ERROR_MSG = "Could Not Add Sales Rep to Agency.";
export const TENANT_ADD_SALES_REPS_TO_AGENCY_SUCCESS_MSG = "Sales Rep Added to Agency Successfully.";
// Retrieve Tenant Agency Main Sales Rep Details
export const RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_ERROR_MSG = "Could Not Retrieve Agency Main Sales Rep Details.";
export const RETRIEVE_TENANT_AGENCY_MAIN_SALES_REP_DETAILS_SUCCESS_MSG = "Agency Main Sales Rep Details Retrieved Successfully.";
// Tenant Update Agency Main Sales Rep Details
export const RETRIEVE_TENANT_UPDATE_AGENCY_MAIN_SALES_REP_ERROR_MSG = "Could Not Update Agency Main Sales Rep Details.";
export const RETRIEVE_TENANT_UPDATE_AGENCY_MAIN_SALES_REP_SUCCESS_MSG = "Agency Main Sales Rep Details Updated Successfully.";
// Tenant Update Product Price
export const UPDATE_TENANT_PRODUCT_PRICE_ERROR_MSG = "Could Not Update Product Price.";
export const UPDATE_TENANT_PRODUCT_PRICE_SUCCESS_MSG = "Product Price Updated Successfully.";
// Retireve Tenant Budget Allocations
export const RETRIEVE_TENANT_BUDGET_ALLOCATIONS_ERROR_MSG = "Could Not Retrieve Budget Allocations.";
export const RETRIEVE_TENANT_BUDGET_ALLOCATIONS_SUCCESS_MSG = "Budget Allocations Retrieved Successfully.";
// Retireve Data
export const COULD_NOT_RETRIEVE_DATA_ERROR_MSG = "Could Not Retrieve Data.";
export const COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG = "Data Retrieved Successfully.";
// Add Tenant Budget Allocations
export const ADD_TENANT_BUDGET_ALLOCATION_ERROR_MSG = "Could Not Add Budget Allocation.";
export const ADD_TENANT_BUDGET_ALLOCATION_SUCCESS_MSG = "Budget Allocation Added Successfully.";
// Retrieve Budget Allocation Details
export const RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_ERROR_MSG = "Could Not Retrieve Allocation Details.";
export const RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_SUCCESS_MSG = "Allocation Details Retrieved Successfully.";
// Delete Order Item
export const DELETE_ORDER_ITEM_ERROR_MSG = "Could Not Delete Order Item Details.";
export const DELETE_ORDER_ITEM_SUCCESS_MSG = "Order Item Deleted Successfully.";
// Retrieve Ready For Dispatch Setting
export const RETRIEVE_READY_FOR_DISPATCH_SETTING_ERROR_MSG = "Could Not Retrieve Ready for Dispatch Settings.";
export const RETRIEVE_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG = "Ready for Dispatch Settings Retrieved Successfully.";
// Update Ready For Dispatch Setting
export const UPDATE_READY_FOR_DISPATCH_SETTING_ERROR_MSG = "Could Not Update Ready for Dispatch Settings.";
export const UPDATE_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG = "Ready for Dispatch Settings Updated Successfully.";
// Delete Employee From Ready For Dispatch Setting
export const DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_SETTING_ERROR_MSG = "Could Not Delete Employee From Ready for Dispatch Notifications.";
export const DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG = "Ready for Dispatch Notification Employee Deleted Successfully.";
// Update Product Viewable on Webstore
export const UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_ERROR_MSG = "Could Not Update Product Viewable on Webstore.";
export const UPDATE_PRODUCT_VIEWABLE_ON_WEBSITE_SUCCESS_MSG = "Product Viewable on Webstore Updated Successfully.";
// Retrieve Brand Settings
export const RETRIEVE_BRANDS_SETTINGS_ERROR_MSG = "Could Not Retrieve Brand Settings.";
export const RETRIEVE_BRANDS_SETTINGS_SUCCESS_MSG = "Brand Settings Retrieved Successfully.";
// Retrieve Brand Settings
export const UPDATE_TENANT_BRAND_SETTINGS_ERROR_MSG = "Could Not Update Brand Settings.";
export const UPDATE_TENANT_BRAND_SETTINGS_SUCCESS_MSG = "Brand Settings Updated Successfully.";
// Delete Tenant Brand
export const DELETE_TENANT_BRAND_ERROR_MSG = "Could Not Delete Brand.";
export const DELETE_TENANT_BRAND_SUCCESS_MSG = "Brand Deleted Successfully.";
// Update Theoretical Stock to Physical Stock Balance
export const TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_ERROR_MSG = "Could Not Update Theoretical Stock to Physical Stock Balance.";
export const TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_SUCCESS_MSG = "Theoretical Stock to Physical Stock Balance Updated Successfully.";
// Update Stock Take Products
export const TENANT_UPDATE_STOCK_TAKE_PRODUCTS_ERROR_MSG = "Could Not Update Stock Take Products.";
export const TENANT_UPDATE_STOCK_TAKE_PRODUCTS_SUCCESS_MSG = "Stock Take Products Updated Successfully.";
// Update Stock Take Products
export const TENANT_RETRIEVE_SALES_REP_DETAILS_ERROR_MSG = "Could Not Retrieve Sales Rep Details.";
export const TENANT_RETRIEVE_SALES_REP_DETAILS_SUCCESS_MSG = "Sales Rep Details Retrieved Successfully.";
// Retrieve Agency Sales Rep Settings
export const TENANT_RETRIEVE_AGENCY_SALES_REP_APPROVAL_SETTINGS_ERROR_MSG = "Could Not Retrieve Sales Rep Settings.";
export const TENANT_RETRIEVE_AGENCY_SALES_REP_APPROVAL_SETTINGS_SUCCESS_MSG = " Sales Rep Settings Retrieved Successfully.";
// Retrieve Stock Levels
export const TENANT_RETRIEVE_RETRIEVE_STOCK_LEVELS_ERROR_MSG = "Could Not Retrieve Stock Levels.";
export const TENANT_RETRIEVE_RETRIEVE_STOCK_LEVELS_SUCCESS_MSG = "Stock Levels Retrieved Successfully.";
// Retrieve Stock Movemnet Suspension Settings
export const RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_ERROR_MSG = "Could Not Retrieve Stock Movement Suspension Settings.";
export const RETRIEVE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_SUCCESS_MSG = "Stock Movement Suspension Settings Retrieved Successfully.";
// Update Stock Movemnet Suspension Settings
export const UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_ERROR_MSG = "Could Not Update Stock Movement Suspension Settings.";
export const UPDATE_TENANT_STOCK_MOVEMENT_SUSPENSION_SETTINGS_SUCCESS_MSG = "Stock Movement Suspension Settings Updated Successfully.";
// Retrieve Sales Rep Details
export const RETRIEVE_SALES_REP_DETAIL_ERROR_MSG = "Could Not Retrieve Sales Rep Details";
export const RETRIEVE_SALES_REP_DETAIL_SUCCESS_MSG = "Sales Rep Details Retrieved Successfully.";
//Update Budget Allocation
export const UPDATE_BUDGET_ALLOCATION_ERROR_MSG = "Could Not Update Budget Allocation.";
export const UPDATE_BUDGET_ALLOCATION_SUCCESS_MSG = "Budget Allocation Updated Successfully.";
//Tenant Toggle Sales Rep Brands
export const TENANT_TOGGLE_SALES_REP_BRAND_ERROR_MSG = "Could Not Toggle Sales Rep Brand.";
export const TENANT_TOGGLE_SALES_REP_BRAND_SUCCESS_MSG = "Sales Rep Brand Toggled Successfully.";
//Tenant Toggle Sales Rep Brands
export const TENANT_TOGGLE_SALES_REP_BRAND_PRODUCT_TYPE_ERROR_MSG = "Could Not Toggle Sales Rep Brand Product Type.";
export const TENANT_TOGGLE_SALES_REP_BRAND_PRODUCT_TYPE_SUCCESS_MSG = "Sales Rep Brand Product Type Toggled Successfully.";
//Cancel Order Item
export const CANCEL_ORDER_ITEM_ERROR_MSG = "Could Not Cancel Order Item.";
export const CANCEL_ORDER_ITEM_SUCCESS_MSG = "Order Item Cancelled Successfully.";
//Retrieve Tenant Modules
export const RETRIEVE_TENANT_MODULES_ERROR_MSG = "Could Not Retrive Tenant Modules.";
export const RETRIEVE_TENANT_MODULES_SUCCESS_MSG = "Tenant Modules Retrieved Successfully.";
// Add Module to Tenant
export const ADD_MODULE_TO_TENANT_ERROR_MSG = "Could not Add Module to Tenant.";
export const ADD_MODULE_TO_TENANT_SUCCESS_MSG = "Module Successfully Added to Tenant.";
// Add Employe to Tenant Module
export const ADD_EMPLOYEE_TO_TENANT_MODULE_ERROR_MSG = "Could not Add Employee to Tenant Module.";
export const ADD_EMPLOYEE_TO_TENANT_MODULE_SUCCESS_MSG = "Employee Successfully Added to Tenant Module.";
// Retrieve Promotions
export const RETRIEVE_PROMOTIONS_ERROR_MSG = "Could not Retrieve Promotions.";
export const RETRIEVE_PROMOTIONS_SUCCESS_MSG = "Promotions Retrieved Successfully.";
// UPdate USSD
export const UPDATE_USSD_ERROR_MSG = "Could not Update USSD Code.";
export const UPDATE_USSD_SUCCESS_MSG = "USSD Code Updated Successfully.";
// Create Promotion
export const CREATE_PROMOTION_ERROR_MSG = "Could not Create Promotion.";
export const CREATE_PROMOTION_SUCCESS_MSG = "Promotion Created Successfully.";
// Retrieve Promotion Details
export const RETRIEVE_PROMOTION_DETAILS_ERROR_MSG = "Could not Retrieve Promotion Details.";
export const RETRIEVE_PROMOTION_DETAILS_SUCCESS_MSG = "Promotion Details Retrieved Successfully.";
// Create Promotion Draw
export const CREATE_PROMOTION_DRAW_ERROR_MSG = "Could not Create Draw.";
export const CREATE_PROMOTION_DRAW_SUCCESS_MSG = "Draw Created Successfully.";
// Retrieve Promotion Draw Details
export const RETRIEVE_PROMOTION_DRAW_DETAILS_ERROR_MSG = "Could not Retrieve Promotion Draw Details.";
export const RETRIEVE_PROMOTION_DRAW_DETAILS_SUCCESS_MSG = "Promotion Draw Details Retrieved Successfully.";
// Retrieve Promotion Draw Participants
export const RETRIEVE_PROMOTION_DRAW_PARTICIPANTS_ERROR_MSG = "Could not Retrieve Promotion Draw Participants.";
export const RETRIEVE_PROMOTION_DRAW_PARTICIPANTS_SUCCESS_MSG = "Promotion Draw Participants Retrieved Successfully.";
// Retrieve Participants
export const RETRIEVE_PARTICIPANTS_ERROR_MSG = "Could not Retrieve Participants.";
export const RETRIEVE_PARTICIPANTS_SUCCESS_MSG = "Participants Retrieved Successfully.";
// Retireve Stock Age Analysis Reducer
export const COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_SUMMARY_ERROR_MSG = "Could Not Retrieve Stock Age Analysis Summary.";
export const COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_SUMMARY_SUCCESS_MSG = "Stock Age Analysis Summary Retrieved Successfully.";
// Tenant Select Draw Winner
export const TENANT_SELECT_DRAW_WINNER_ERROR_MSG = "Could Not Select Draw Winner.";
export const TENANT_SELECT_DRAW_WINNER_SUCCESS_MSG = "Draw Winner Selected Successfully.";
// Could not Retrieve Settings
export const TENANT_COULD_NOT_RETIREVE_SETTINGS_ERROR_MSG = "Could Not Retrieve Settings.";
export const TENANT_COULD_NOT_RETIREVE_SETTINGS_SUCCESS_MSG = "Settings Retrieved Successfully.";
// Retireve Stock Age Analysis Reducer
export const COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_ERROR_MSG = "Could Not Retrieve Stock Age Brand Analysis Summary.";
export const COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_SUCCESS_MSG = "Stock Age Analysis Brand Analysis Retrieved Successfully.";
// Retireve Stock Age Analysis Brand Analysis Data
export const COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_DATA_ERROR_MSG = "Could Not Retrieve Stock Age Brand Analysis Data.";
export const COULD_NOT_RETRIEVE_STOCK_AGE_ANALYSIS_BRAND_ANALYSIS_DATA_SUCCESS_MSG = "Stock Age Analysis Brand Analysis Retrieved Successfully.";
// Retireve Product Stock Age Analysis BreakDown
export const COULD_NOT_RETRIEVE_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_ERROR_MSG = "Could Not Retrieve Product Stock Age Analysis Breakdown.";
export const COULD_NOT_RETRIEVE_PRODUCT_STOCK_AGE_ANALYSIS_BREAKDOWN_SUCCESS_MSG = "Product Stock Age Analysis Breakdown Retrieved Successfully.";
// Retireve Goods Issued List
export const COULD_NOT_RETRIEVE_GOODS_ISSUED_LIST_ERROR_MSG = "Could Not Retrieve Goods Issued List.";
export const COULD_NOT_RETRIEVE_GOODS_ISSUED_LIST_SUCCESS_MSG = "Goods Issued List Retrieved Successfully.";
// Retrieve Settings Details
export const RETRIVE_SETTINGS_DETAILS_ERROR_MSG = "Could Not Retrive Settings Details.";
export const RETRIVE_SETTINGS_DETAILS_SUCCESS_MSG = "Setting Details Retrieved Successfully.";
// Update Settings Details
export const UPDATE_SETTINGS_DETAILS_ERROR_MSG = "Could Not Update Settings.";
export const UPDATE_SETTINGS_DETAILS_SUCCESS_MSG = "Setting Details Updated Successfully.";
// Delete Restricted Number
export const DELETE_RESTRICTED_NUMBER_ERROR_MSG = "Could Not Delete Restricted Number.";
export const DELETE_RESTRICTED_NUMBER_SUCCESS_MSG = "Restricted Number Deleted Successfully.";
// Delete Message
export const DELETE_MESSAGE_ERROR_MSG = "Could Not Delete Message.";
export const DELETE_MESSAGE_SUCCESS_MSG = "Message Deleted Successfully.";